import { useEffect, useRef, useState } from 'react';

/**
 * manages portal visibility synchronized with drawer/overlay animations
 * shows portal immediately when drawer opens, delays hiding on close to allow exit animations
 */
const usePortalSync = (isDrawerOpen: boolean, delay = 300): boolean => {
  const [shouldShowPortal, setShouldShowPortal] = useState(false);
  const closeTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (isDrawerOpen) {
      // clear any pending close timeout
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
        closeTimeoutRef.current = null;
      }

      // show portal immediately when drawer opens
      setShouldShowPortal(true);
    } else {
      // delay hiding portal to allow exit animations
      closeTimeoutRef.current = setTimeout(() => {
        setShouldShowPortal(false);
        closeTimeoutRef.current = null;
      }, delay);
    }

    return () => {
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
      }
    };
  }, [isDrawerOpen, delay]);

  return shouldShowPortal;
};

export default usePortalSync;
